import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import DatePicker from "components/common_components/DatePicker/DatePicker";

function DatePickerField({ fieldName, helperText, ...rest }) {
    return (
        <Field type="date" name={fieldName}>
            {({ field, form: { setFieldValue, touched, errors } }) => (
                <DatePicker
                    {...field}
                    {...rest}
                    onChange={(date) => setFieldValue(field.name, date)}
                    helperText={helperText}
                    error={touched[field.name] && errors[field.name]}
                />
            )}
        </Field>
    );
}

DatePickerField.propTypes = {
    margin: PropTypes.string,
    fieldName: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    fullWidth: PropTypes.bool,
    inputVariant: PropTypes.string,
    size: PropTypes.string,
};

DatePickerField.defaultProps = {
    margin: "normal",
    helperText: undefined,
    fullWidth: true,
    inputVariant: "outlined",
    size: "small",
};

export default DatePickerField;
